// ไฟล์: frontend/src/pages/admin/Dashboard.js
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/Header';
import Sidebar from '../../components/Sidebar';
import Footer from '../../components/Footer';
import api from '../../services/api';
import Swal from 'sweetalert2';
import { DEFAULT_AVATAR } from '../../assets/default_avatar';

function AdminDashboard() {
  const [dashboardData, setDashboardData] = useState({
    studentCount: 0,
    classCount: 0,
    teacherCount: 0,
    latestStudents: [],
    latestClasses: []
  });
  const [isLoading, setIsLoading] = useState(true);
  
  useEffect(() => {
    // เรียกข้อมูลสำหรับแดชบอร์ด
    const fetchDashboardData = async () => {
      try {
        // ดึงข้อมูลจำนวนนักเรียน
        const studentsResponse = await api.student.getAllStudents();
        const students = studentsResponse.data.data || [];
        
        // ดึงข้อมูลจำนวนชั้นเรียน
        const classesResponse = await api.class.getAllClasses();
        const classes = classesResponse.data.data || [];
        
        // ดึงข้อมูลจำนวนครู
        const teachersResponse = await api.user.getAllTeachers();
        const teachers = teachersResponse.data.data || [];
        
        // ตั้งค่าข้อมูลแดชบอร์ด
        setDashboardData({
          studentCount: students.length,
          classCount: classes.length,
          teacherCount: teachers.length,
          latestStudents: students.slice(0, 5), // 5 นักเรียนล่าสุด
          latestClasses: classes.slice(0, 5)    // 5 ชั้นเรียนล่าสุด
        });
      } catch (error) {
        console.error('Error fetching dashboard data:', error);
        Swal.fire({
          icon: 'error',
          title: 'เกิดข้อผิดพลาด',
          text: 'ไม่สามารถโหลดข้อมูลแดชบอร์ดได้',
          confirmButtonColor: '#ff6b01'
        });
      } finally {
        setIsLoading(false);
      }
    };
    
    fetchDashboardData();
  }, []);
  
  return (
    <div className="wrapper">
      <Header />
      <Sidebar />
      
      <div className="content-wrapper">
        <div className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                <h1 className="m-0">แดชบอร์ดผู้ดูแลระบบ</h1>
              </div>
              <div className="col-sm-6">
                <ol className="breadcrumb float-sm-right">
                  <li className="breadcrumb-item active">แดชบอร์ด</li>
                </ol>
              </div>
            </div>
          </div>
        </div>
        
        <section className="content">
          <div className="container-fluid">
            {isLoading ? (
              <div className="loading-spinner">
                <i className="fas fa-spinner fa-spin"></i>
              </div>
            ) : (
              <>
                {/* สรุปข้อมูล */}
                <div className="row">
                  {/* นักเรียน */}
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="small-box bg-info">
                      <div className="inner">
                        <h3>{dashboardData.studentCount}</h3>
                        <p>นักเรียนทั้งหมด</p>
                      </div>
                      <div className="icon">
                        <i className="fas fa-user-graduate"></i>
                      </div>
                      <Link to="/admin/students" className="small-box-footer">
                        ข้อมูลเพิ่มเติม <i className="fas fa-arrow-circle-right"></i>
                      </Link>
                    </div>
                  </div>
                  
                  {/* ชั้นเรียน */}
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="small-box bg-orange">
                      <div className="inner">
                        <h3>{dashboardData.classCount}</h3>
                        <p>ชั้นเรียนทั้งหมด</p>
                      </div>
                      <div className="icon">
                        <i className="fas fa-chalkboard"></i>
                      </div>
                      <Link to="/admin/classes" className="small-box-footer">
                        ข้อมูลเพิ่มเติม <i className="fas fa-arrow-circle-right"></i>
                      </Link>
                    </div>
                  </div>
                  
                  {/* ครู */}
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="small-box bg-success">
                      <div className="inner">
                        <h3>{dashboardData.teacherCount}</h3>
                        <p>ครูผู้สอนทั้งหมด</p>
                      </div>
                      <div className="icon">
                        <i className="fas fa-chalkboard-teacher"></i>
                      </div>
                      <Link to="/admin/teachers" className="small-box-footer">
                        ข้อมูลเพิ่มเติม <i className="fas fa-arrow-circle-right"></i>
                      </Link>
                    </div>
                  </div>
                </div>
                
                {/* นักเรียนล่าสุด */}
                <div className="row">
                  <div className="col-md-6">
                    <div className="card card-orange">
                      <div className="card-header">
                        <h3 className="card-title">นักเรียนล่าสุด</h3>
                        <div className="card-tools">
                          <Link to="/admin/students" className="btn btn-tool">
                            <i className="fas fa-users"></i> ดูทั้งหมด
                          </Link>
                        </div>
                      </div>
                      <div className="card-body p-0">
                        <ul className="users-list clearfix">
                          {dashboardData.latestStudents.map((student) => (
                            <li key={student.id} className="text-center p-2">
                              <img 
                                src={`https://cms2568.backend.kruwirat.com/uploads/${student.profile_pic}`} 
                                alt={`${student.first_name} ${student.last_name}`} 
                                className="student-profile-pic"
                                onError={(e) => { e.target.onerror = null; e.target.src = DEFAULT_AVATAR; }}
                                />
                              <p className="users-list-name">{student.first_name} {student.last_name}</p>
                              <span className="users-list-date">{student.student_id}</span>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                  
                  {/* ชั้นเรียนล่าสุด */}
                  <div className="col-md-6">
                    <div className="card card-orange">
                      <div className="card-header">
                        <h3 className="card-title">ชั้นเรียนล่าสุด</h3>
                        <div className="card-tools">
                          <Link to="/admin/classes" className="btn btn-tool">
                            <i className="fas fa-chalkboard"></i> ดูทั้งหมด
                          </Link>
                        </div>
                      </div>
                      <div className="card-body p-0">
                        <table className="table">
                          <thead>
                            <tr>
                              <th>ชั้นเรียน</th>
                              <th>ห้อง</th>
                              <th>ครูประจำชั้น</th>
                              <th>จำนวนนักเรียน</th>
                            </tr>
                          </thead>
                          <tbody>
                            {dashboardData.latestClasses.map((classItem) => (
                              <tr key={classItem.id}>
                                <td>
                                  <Link to={`/admin/classes/${classItem.id}`}>
                                    {classItem.class_name}
                                  </Link>
                                </td>
                                <td>{classItem.room_number}</td>
                                <td>{classItem.teacher_name || 'ยังไม่มีครูประจำชั้น'}</td>
                                <td>
                                  <span className="badge bg-primary">{classItem.student_count || 0} คน</span>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </section>
      </div>
      
      <Footer />
    </div>
  );
}

export default AdminDashboard;